"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JUMBLE_LAYOUT_STYLES = exports.COLLAGE_LAYOUT_STYLES = void 0;
var COLLAGE_LAYOUT_STYLES;
(function (COLLAGE_LAYOUT_STYLES) {
    COLLAGE_LAYOUT_STYLES["GRID"] = "grid";
    COLLAGE_LAYOUT_STYLES["NOTES"] = "notes";
    COLLAGE_LAYOUT_STYLES["HEART"] = "heart";
    COLLAGE_LAYOUT_STYLES["MIXED"] = "mixed";
    COLLAGE_LAYOUT_STYLES["CENTERED"] = "centered";
})(COLLAGE_LAYOUT_STYLES = exports.COLLAGE_LAYOUT_STYLES || (exports.COLLAGE_LAYOUT_STYLES = {}));
var JUMBLE_LAYOUT_STYLES;
(function (JUMBLE_LAYOUT_STYLES) {
    JUMBLE_LAYOUT_STYLES["heart"] = "heart";
    JUMBLE_LAYOUT_STYLES["blocks"] = "blocks";
    JUMBLE_LAYOUT_STYLES["pixels"] = "pixels";
    JUMBLE_LAYOUT_STYLES["square"] = "square";
    JUMBLE_LAYOUT_STYLES["rectangle"] = "rectangle";
    JUMBLE_LAYOUT_STYLES["domino"] = "domino";
    JUMBLE_LAYOUT_STYLES["tree"] = "tree";
    JUMBLE_LAYOUT_STYLES["star"] = "star";
    JUMBLE_LAYOUT_STYLES["circle"] = "circle";
    JUMBLE_LAYOUT_STYLES["love"] = "love";
})(JUMBLE_LAYOUT_STYLES = exports.JUMBLE_LAYOUT_STYLES || (exports.JUMBLE_LAYOUT_STYLES = {}));
//# sourceMappingURL=collageLayoutStyles.js.map